// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { z as zod } from 'zod';

/**
 * Get all cohorts
 * @summary Get All Cohorts
 */
export const getAllCohortsCohortsGetQueryParams = zod.object({
  state: zod.coerce.string().or(zod.null()).optional(),
  page: zod.coerce.number().optional(),
  pageSize: zod.coerce.number().optional(),
  sort: zod.coerce.string().optional(),
  filter: zod.coerce.string().optional(),
});

export const getAllCohortsCohortsGetResponse = zod
  .object({
    data: zod.any().or(zod.null()).optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Create cohort
 * @summary Create Cohort
 */
export const createCohortCohortsPostBody = zod
  .object({
    title: zod.string(),
    state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
    isDeprecated: zod.boolean().or(zod.null()).optional(),
  })
  .strict();

export const createCohortCohortsPostResponse = zod
  .object({
    data: zod.any().or(zod.null()).optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Get cohort
 * @summary Get Cohort
 */
export const getCohortCohortsCohortIdGetParams = zod
  .object({
    cohort_id: zod.coerce.string(),
  })
  .strict();

export const getCohortCohortsCohortIdGetResponse = zod
  .object({
    data: zod.any().or(zod.null()).optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Update cohort
 * @summary Update Cohort
 */
export const updateCohortCohortsCohortIdPutParams = zod
  .object({
    cohort_id: zod.coerce.string(),
  })
  .strict();

export const updateCohortCohortsCohortIdPutBody = zod
  .object({
    title: zod.string(),
    state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
    isDeprecated: zod.boolean().or(zod.null()).optional(),
  })
  .strict();

export const updateCohortCohortsCohortIdPutResponse = zod
  .object({
    data: zod
      .object({
        id: zod.string(),
        title: zod.string(),
        state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
        isDeprecated: zod.boolean().optional(),
        stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Delete cohort
 * @summary Delete Cohort
 */
export const deleteCohortCohortsCohortIdDeleteParams = zod
  .object({
    cohort_id: zod.coerce.string(),
  })
  .strict();

export const deleteCohortCohortsCohortIdDeleteResponse = zod
  .object({
    data: zod.any().or(zod.null()).optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();
